module.exports = __webpack_public_path__ + "static/media/not-found.ab00de76.png";